import { RequestDirectionType } from 'common/common.types';

export const getCategoryTitleTranslationKey = (
  category: string,
  requestType: RequestDirectionType,
) => `Requests.${category === 'created' ? requestType : category}`;
